import React from 'react';
const whatsappNumber = '918055857625';



function ReelChallenge() {

  const handleHowToParticipate = () => {
    window.open('https://youtube.com/@rskpay?si=kT4xqSwcqp9ph6oa', '_blank');
  };

  const handleParticipate = () => {
    const simpleMsg = `Hi I'm Interested`;
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(simpleMsg)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="reel-challenge-page" style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'linear-gradient(135deg, #232526 0%, #414345 100%)' }}>
      <div className="reel-challenge-card" style={{ background: '#18181c', borderRadius: 18, boxShadow: '0 8px 32px rgba(37,211,102,0.12)', padding: '32px 24px', maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <img src={process.env.PUBLIC_URL + '/rskpay-logo.png'} alt="RSKPay Logo" style={{ width: 70, marginBottom: 18 }} />
        <h1 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: 12, background: 'linear-gradient(135deg, #25D366 0%, #764ba2 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>RSKPay Reel Challenge</h1>
        <p style={{ color: '#e0e0e0', fontSize: 16, marginBottom: 24 }}>
          Participate in our Instagram Reel Challenge and win exciting rewards!<br />
          <span style={{ color: '#25D366', fontWeight: 600 }}>Click below to get started.</span>
        </p>
        <button onClick={handleHowToParticipate} style={{ padding: '12px 24px', fontSize: 17, background: '#fff', color: '#25D366', border: 'none', borderRadius: 8, fontWeight: 700, marginBottom: 18, width: '100%', boxShadow: '0 2px 8px rgba(37,211,102,0.08)' }}>
          📺 How to Participate
        </button>
        <button onClick={handleParticipate} style={{ padding: '14px 24px', fontSize: 18, background: '#25D366', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, width: '100%', boxShadow: '0 2px 8px rgba(37,211,102,0.18)' }}>
          🚀 Participate Now
        </button>
      </div>
    </div>
  );
}

export default ReelChallenge;
